import clsx from 'clsx';
import InnerHTML from 'dangerously-set-html-content';
import __isEmpty from 'lodash/isEmpty';
import styles from './text.module.scss';

export default function Text(props) {
    const { text, className, estil, tag } = props;
    const stylesText = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });
    const CustomTag = `${tag}`;

    if (tag === 'div') {
        return <InnerHTML className={stylesText} html={text} />;
    } else {
        return <CustomTag className={stylesText} dangerouslySetInnerHTML={{ __html: text }}></CustomTag>;
    }
}

Text.defaultProps = {
    text: '',
    tag: 'div',
    className: null,
    estil: null
};
